import React from 'react'
import useFullscreen from '../hooks/fullscreen.js'
import { connect, Provider } from 'react-redux'
import store from '../store'
import * as annotationActions from '../pdfjs/annotations/actions'
import * as documentActions from '../pdfjs/document/action-creators.js'
import localStorage from '../common/local-storage'
import Viewer from '../pdfjs/Viewer'

const ReduxConnectedApp = connect((state) => state, {
  ...annotationActions,
  ...documentActions,
})(Viewer)

const PDFjsViewer = (props) => {
  const [isFullscreen, toggleFullscreen] = useFullscreen({
    node: document.querySelector('#App'),
    onToggle: () => document.querySelector('.full-screen-button').focus(),
  })

  return (
    <Provider store={store}>
      <ReduxConnectedApp
        isFullscreen={isFullscreen}
        localStorage={localStorage}
        toggleFullscreen={toggleFullscreen}
        {...props}
      />
    </Provider>
  )
}

export default PDFjsViewer
